(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_announcement"] && !Shopify.designMode) return;
  try {
    // almost certainly not the right place for this:
const urlSearchParams = new URLSearchParams(window.location.search);
function getParam(name) {
  return urlSearchParams.get(name);
}
const discountCode = getParam('discount');

function addAnnoucement(html) {
  const slides = document.querySelector('.announcement-bar__slides');
  if (!slides) return;
  const firstSlide = slides.querySelector('slideshow-slide');
  if (!firstSlide) return;
  // save the original first slide, we will use it as the 2nd slide
  const cloneSlide = firstSlide.cloneNode(true);
  cloneSlide.setAttribute('aria-hidden', "true");
  // change first slide
  const text = firstSlide.querySelector('.announcement-bar__text');
  text.innerHTML = html;
  firstSlide.after(cloneSlide);
}

if (discountCode && discountCode == '4CT4FREE') addAnnoucement('<strong>Add to Cart to Receive Your FREE 4CT</strong>');
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    let styleDeliveryPromiseAttempts = 10;
function styleDeliveryPromise() {
  styleDeliveryPromiseAttempts--;
  if (!styleDeliveryPromiseAttempts) return;

  let styled = false;

  const buyButtonsBlock = document.querySelector('.buy-buttons-block');
  const deliveryPromiseWC = buyButtonsBlock.querySelector('delivery-promise-wc');

  if (buyButtonsBlock && deliveryPromiseWC && deliveryPromiseWC.offsetHeight) buyButtonsBlock.classList.add('styled-delivery-promise');
  else setTimeout(styleDeliveryPromise, 250);
}
styleDeliveryPromise();
  } catch(e) { console.error(e); }
})();

})();
